module.exports = __webpack_public_path__ + "media/a1.bd0cc393.mp3";